import React from 'react';
import { motion } from 'framer-motion';
import { Star, Globe, Heart, Gem } from 'lucide-react';
const services = [{
  id: 1,
  title: '日韩佳丽',
  subtitle: 'Japanese & Korean',
  description: 'Refined elegance from Tokyo and Seoul. Known for their gentle demeanor and impeccable etiquette.',
  icon: Star,
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=500&fit=crop&crop=faces'
}, {
  id: 2,
  title: '欧美佳丽',
  subtitle: 'Western',
  description: 'Sophisticated international companions bringing worldly charm and engaging conversation.',
  icon: Globe,
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=500&fit=crop&crop=faces'
}, {
  id: 3,
  title: '越南佳丽',
  subtitle: 'Vietnamese',
  description: 'Grace and traditional charm from Hanoi and Saigon. A perfect blend of sweetness and beauty.',
  icon: Heart,
  image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=400&h=500&fit=crop&crop=faces'
}, {
  id: 4,
  title: '中国佳丽',
  subtitle: 'Chinese',
  description: 'Classic beauty with modern sophistication. Cultured, elegant, and perfectly attuned to your needs.',
  icon: Gem,
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=500&fit=crop&crop=faces'
}];
export function ServiceHighlights() {
  return <section className="py-24 md:py-32 bg-dark-bg relative" data-id="element-95">
      <div className="max-w-7xl mx-auto px-6" data-id="element-96">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-97">
          <h2 className="text-4xl md:text-5xl font-serif text-gold-100 mb-4" data-id="element-98">
            精选佳丽 <span className="text-gold-400 mx-2" data-id="element-99">·</span> Our
            Companions
          </h2>
          <div className="w-16 h-[1px] bg-gold-400/30 mx-auto mt-6" data-id="element-100"></div>
        </motion.div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-101">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15,
          ease: 'easeOut'
        }} className="group relative bg-dark-surface border border-gold-400/10 rounded-lg overflow-hidden hover:border-gold-400/30 transition-all duration-500 hover:shadow-[0_0_30px_rgba(201,169,110,0.1)]" data-id="element-102">
              {/* Image */}
              <div className="relative h-56 overflow-hidden" data-id="element-103">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700" data-id="element-104" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-surface via-dark-surface/30 to-transparent" data-id="element-105" />
                <div className="absolute top-4 right-4 inline-flex items-center justify-center w-10 h-10 rounded-full bg-dark-bg/60 backdrop-blur-sm text-gold-400 border border-gold-400/20" data-id="element-106">
                  <service.icon className="w-5 h-5" data-id="element-107" />
                </div>
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-108">
                <h3 className="text-2xl font-serif text-gold-100 mb-1 group-hover:text-gold-300 transition-colors duration-300" data-id="element-109">
                  {service.title}
                </h3>
                <p className="text-sm text-gold-500 uppercase tracking-wider mb-4 font-medium" data-id="element-110">
                  {service.subtitle}
                </p>

                <p className="text-gold-100/60 leading-relaxed text-sm" data-id="element-111">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}